import useFeatureFlag from '../useFeatureFlag';

export function useUserManager() {
  return useFeatureFlag('APP3047_User_Manager', false);
}
